export default __webpack_public_path__ + "static/heartopener_3-a1439a3b21b074b73f4209295ba61466.jpg";